"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dd_api_1 = __importDefault(require("../dd-api"));
class DDContactApi extends dd_api_1.default {
    constructor(api_host, client) {
        super(api_host, client);
    }
    async getContact(idType, idValue) {
        const response = await this.get(`/contacts/v3/${idType}/${idValue}`);
        return response.data;
    }
    async fetchOrCreateContact(channelIdentifier, data) {
        const [[idType, idValue]] = Object.entries(channelIdentifier);
        const response = await this.patch(`/contacts/v3/${idType}/${idValue}`, data);
        return response.data;
    }
    async upsertContact(payload) {
        const { channelIdentifier, emailIdentifier, mobileNumberIdentifier, emailType = 'html', optInType = 'single', updateEmailSubscription = true, emailSubscriptionStatus = 'subscribed', emailResubscribe = false, resubscribeWithoutChallengeEmail = false, preferredLocale, redirectUrlAfterChallenge, updateSmsSubscription = true, smsSubscriptionStatus = 'subscribed', listId, dataFields } = payload;
        const idValue = channelIdentifier === 'email' ? emailIdentifier : mobileNumberIdentifier;
        const identifiers = {
            ...(emailIdentifier && { email: emailIdentifier }),
            ...(mobileNumberIdentifier && { mobileNumber: mobileNumberIdentifier })
        };
        const channelProperties = {};
        if (emailIdentifier) {
            channelProperties.email = {
                emailType,
                optInType
            };
            if (updateEmailSubscription) {
                if (emailSubscriptionStatus === 'subscribed') {
                    if (emailResubscribe) {
                        channelProperties.email.status = 'subscribed';
                        const resubscribeOptions = {
                            resubscribeWithNoChallenge: resubscribeWithoutChallengeEmail
                        };
                        if (!resubscribeWithoutChallengeEmail) {
                            if (preferredLocale)
                                resubscribeOptions.preferredLocale = preferredLocale;
                            if (redirectUrlAfterChallenge)
                                resubscribeOptions.redirectUrlAfterChallenge = redirectUrlAfterChallenge;
                        }
                        channelProperties.email.resubscribeOptions = resubscribeOptions;
                    }
                }
                else if (emailSubscriptionStatus) {
                    channelProperties.email.status = emailSubscriptionStatus;
                }
            }
        }
        if (mobileNumberIdentifier && updateSmsSubscription && smsSubscriptionStatus) {
            channelProperties.sms = {
                status: smsSubscriptionStatus
            };
        }
        const data = {
            identifiers,
            channelProperties,
            ...(listId && { lists: [listId] }),
            dataFields: dataFields
        };
        const response = await this.patch(`/contacts/v3/${channelIdentifier}/${idValue}?merge-option=overwrite`, data);
        return response.data;
    }
    async unsubscribeContact(payload) {
        const { channelIdentifier, emailIdentifier, mobileNumberIdentifier } = payload;
        const idValue = channelIdentifier === 'email' ? emailIdentifier : mobileNumberIdentifier;
        const identifiers = {
            ...(emailIdentifier && { email: emailIdentifier }),
            ...(mobileNumberIdentifier && { mobileNumber: mobileNumberIdentifier })
        };
        const channelProperties = {
            ...(emailIdentifier && {
                email: { status: 'unsubscribed' }
            }),
            ...(mobileNumberIdentifier && {
                sms: { status: 'unsubscribed' }
            })
        };
        const data = {
            identifiers,
            channelProperties
        };
        const response = await this.patch(`/contacts/v3/${channelIdentifier}/${idValue}?merge-option=overwrite`, data);
        return response.data;
    }
}
exports.default = DDContactApi;
//# sourceMappingURL=dd-contact-api.js.map